import { render } from "./add-kios-modal.vue?vue&type=template&id=344e73ad&scoped=true"
import script from "./add-kios-modal.vue?vue&type=script&lang=js"
export * from "./add-kios-modal.vue?vue&type=script&lang=js"

import "./add-kios-modal.vue?vue&type=style&index=0&id=344e73ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344e73ad"]])

export default __exports__